import jQuery from 'jquery';
import 'magnific-popup';

jQuery(function ($) {
    'use strict';

    $('.people-card').each(function () {
        $(this).magnificPopup({
            type: 'inline',
            midClick: true,
            showCloseBtn: false,
            mainClass: 'people-modal__container',
        });
    });

    $('.people-modal__close').on('click', function () {
        $.magnificPopup.close();
    });
});
